/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-05-20 16:22:41
 * @Description:
 */
export default {
  Problem_feedback: 'Silakan masukkan pertanyaan dan saran Anda.',
  contact_information: 'Silakan masukkan informasi kontak Anda.',
  contact_information_the: 'Silakan masukkan informasi kontak Anda.',
  import: 'memasuki',
  Please_enter: 'Silakan masuk',
  Old_password: 'Kata Sandi Lama',
  New_password: 'Kata Sandi Baru',
  Required: 'Diperlukan',
  Enteranewpassword: 'Masukkan kata sandi baru',
  Confirm_new_password: 'Konfirmasi kata sandi baru',
  mobile: 'Nomor telepon',
  QQ: 'Nomor QQ',
  postbox: 'Surat',
  contact_you: 'Sangat mudah untuk menghubungi Anda.',
  question: 'Silakan masukkan pertanyaan Anda.',
  Characters_up: '6-16 karakter',
  address: 'Silakan masukkan alamat lengkap.',
  renewal_contact: 'Silakan masukkan informasi kontak perpanjangan Anda.',
  ple_contact_name: 'Silakan masukkan nama orang yang dapat dihubungi.',
  Please_enter_withdrawal: 'Silakan tekan "Enter".',
  Number_of_cards: 'kuantitas',
  Pleasechooseanagent: 'Silakan pilih agen',
  Pleaseenterthequantity: 'Silakan masukkan jumlahnya.',
  Pleaseentertheuserprefixnickname: 'Silakan masukkan nama pengguna Anda beserta awalan (2-26 karakter).',
  PleaseEnterImei: 'Silakan masukkan nomor IMEI 15 digit Anda.',
  Remarkswithin: 'Catatan: Maksimal 100 karakter',
  Pleaseselectaunit: 'Silakan pilih unit',
  Pleaseselectagrouptojoin: 'Silakan pilih grup yang ingin Anda ikuti.',
  Pleaseentertheunitname: 'Silakan masukkan nama perusahaan.',
  companynamerequired: '(Diperlukan: 4-20 kata, huruf, dan angka)',
  Pleaseenterloginaccount: 'Silakan masukkan akun login Anda.',
  loginaccountrequired: '(Diperlukan: 6-20 huruf dan angka)',
  Pleaseenteryourpassword: 'Silakan masukkan kata sandi login Anda.',
  loginpasswordrequired: '(Diperlukan: 6-16 huruf dan angka)',
  Pleaseenteracontactname: 'Silakan masukkan nama orang yang dapat dihubungi.',
  contactnamerequired: '(Diperlukan: 2-20 kata, huruf, dan angka)',
  Pleaseenteraprefixname: 'Silakan masukkan nama awalan.',
  prefixnamerequired: '(Diperlukan: 2-12 huruf, angka)',
  Contactnamerequired20: 'Nama orang yang dapat dihubungi (wajib diisi: 2-20 karakter)',
  mobilephonenumber: 'Nomor telepon seluler (opsional)',
  Enteremailaddress: 'Masukkan alamat email Anda (opsional)',
  Enterdetailedaddress: 'Masukkan alamat lengkap (opsional)',
  Pleaseenteragroupname: 'Silakan masukkan nama grup (wajib diisi: 2-15 karakter).',
  Groupnamerequired: 'Nama grup (wajib diisi: 2-15 karakter)',
  Pleasetypeyourphonenumber: 'Silakan masukkan nomor kontak Anda.',
  Pleaseinputtheemailaddress: 'Silakan masukkan alamat email Anda.',
  Pleaseenterthemailingaddress: 'Silakan masukkan alamat pos Anda.',
  RequiredPleaseenterusernickname: '(Wajib diisi) Silakan masukkan nama pengguna Anda',
  Pleasemobilephonenumber: '(Opsional) Silakan masukkan nomor ponsel Anda',
  PleaseentertheoriginalIMEInumber: 'Silakan masukkan nomor IMEI asli Anda yang terdiri dari 15 digit.',
  PleaseenterthenewIMEInumber: 'Silakan masukkan nomor IMEI 15 digit baru Anda.',
  Pleaseenteraverificationcode: 'Silakan masukkan kode verifikasi 4 digit.',
  Pleaseenterthemobilephonenumbertobebound: 'Silakan masukkan nomor ponsel yang ingin Anda tautkan.',
  PleaseenteragroupnameTow: 'Silakan masukkan nama grup.',
  Pleaseenterusername: 'Silakan masukkan nama pengguna Anda.',
  Fencenamerequired: 'Nama pagar (wajib diisi: 1-15 karakter)',
  Pleaseenterthefencename: 'Silakan masukkan nama pagar.',
  Pleaseselectatime: 'Silakan pilih waktu',

  please_rest_password: 'Halo, demi keamanan akun, kami sarankan untuk mengatur ulang kata sandi login Anda terlebih dahulu.',
  TheLastGroupUnderTheUnitCannotBeDeleted: 'Grup terakhir di bawah unit tersebut tidak dapat dihapus.',
}
